import React, { useContext, useMemo } from 'react'
import ModalContext from 'contexts/ModalContext'
import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import MapV2 from './MapV2'
import { isBedbank } from 'lib/offer/offerTypes'
import { OFFER_TYPE_LAST_MINUTE, OFFER_TYPE_VILLA } from 'constants/offer'

const MapContainer = styled.div`
  height: ${rem(140)};

  ${mediaQueryUp.tablet} {
    margin-top: ${rem(32)};
  }

  ${mediaQueryDown.mobile} {
    margin-top: ${rem(12)};
  }

  .location-map {
    height: 100%;
  }
`

const ModalContainer = styled.div`
  height: 100%;

  .location-map {
    height: 100%;
  }
`

const AddressContainer = styled.div`
  margin-top: ${rem(12)};
`

interface Props {
  offer: App.Offer | App.BedbankOffer | App.HotelOffer;
}

function PropertyMapV2({ offer }: Props) {
  const showMapModal = useContext(ModalContext)

  const name = useMemo(() => {
    if (isBedbank(offer) || offer.type === OFFER_TYPE_LAST_MINUTE || offer.type === OFFER_TYPE_VILLA) {
      return offer.name
    } else {
      return offer.location
    }
  }, [offer])

  const address = useMemo(() => isBedbank(offer) ? offer.property.location : (offer.property?.address ?? ''), [offer])

  const openMapModal = () => {
    showMapModal(
      <ModalBase size="max" height="max">
        <ModalHeader title={name} />
        <ModalContainer>
          <MapV2 offer={offer} zoom={15}/>
        </ModalContainer>
      </ModalBase>,
    )
  }

  return (<div>
    <CSSBreakpoint max="mobile">
      <BodyTextBlock variant="large" colour="neutral-two" weight="bold">
        Where you're staying
      </BodyTextBlock>
    </CSSBreakpoint>
    <MapContainer>
      <MapV2 offer={offer} openMapModal={openMapModal} isStatic/>
    </MapContainer>
    <AddressContainer>
      <BodyTextBlock variant="medium" colour="neutral-two">
        {address}
      </BodyTextBlock>
    </AddressContainer>
  </div>
  )
}

export default PropertyMapV2
